import Skeleton from '@mui/material/Skeleton';
import styles from './SkeletonSummaryRow.module.scss';
import { summaryRowIds } from '../../../../lib/tests/testIds';

const SkeletonSummaryRow = () => {
  return <Skeleton data-testid={summaryRowIds.skeletonSummaryRow} variant="rectangular" className={styles.summary} />;
};

export default SkeletonSummaryRow;
